import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";


export function chargeCapitec() {
    const { $charge, $inputs, USE_CUSTOMER_ID } = this;

    let data = {};

    const customernumber = getValueAtPath($inputs, '[customernumber].value');
    const accountnumber = getValueAtPath($inputs, '[accountnumber].value');
    const phonenumber = getValueAtPath($inputs, '[phonenumber].value');
    const capitecPaymentOption = getValueAtPath($inputs, '[capitecPaymentOption].value');

    if (USE_CUSTOMER_ID) {
        data = { identifierId: customernumber }
    } else {
        data = getValueAtPath(capitecPaymentOption, 'identifier') == 'Account number' 
            ? { accountnumber }
            : { phonenumber }
    }

    $charge.init({
        data
    })
}

export default function view() {
    const $this = this;

    return (view = ViewFactory({
        NAME: 'CAPITEC_INIT_VIEW',
        inputs: ['phonenumber', 'accountnumber', 'customernumber', 'capitecPaymentOption'],
        constants: { hasBackAction: false },
        mutables: { useCustomerID: 'USE_CUSTOMER_ID' },
        next() {
            return chargeCapitec.call($this)
        }
    }).call(this));
}

